import AXIOS from "./axios";

export class MedicalCertificates {
  static fetchPatientMedicalCertificates() {
    return AXIOS.get("/medical_certificates");
  }

  static fetchMedicalCertificate(id) {
    return AXIOS.get(`/medical_certificates/${id}`);
  }

  static listAppointmentMedicalCertificates(appointmentId) {
    return AXIOS.get(
      `/admin/appointments/${appointmentId}/medical_certificates`
    );
  }

  static createMedicalCertificate(appointmentId, data) {
    return AXIOS.post(
      `/admin/appointments/${appointmentId}/medical_certificates`,
      {
        medical_certificate: data
      }
    );
  }

  static updateMedicalCertificate(appointmentId, id, data) {
    return AXIOS.put(
      `/admin/appointments/${appointmentId}/medical_certificates/${id}`,
      { medical_certificate: data }
    );
  }

  static deleteMedicalCertificate(appointmentId, id) {
    return AXIOS.delete(
      `/admin/appointments/${appointmentId}/medical_certificates/${id}`
    );
  }
}
